import axios from 'axios';
import { toast } from 'react-toastify';

export const sendNotification = (title, body, destination) => {
    const topic = `/topics/${destination ?? "all"}`
    const data = JSON.stringify({
        "to": topic,
        "collapse_key": "type_a",
        "notification": {
            "title": title,
            "body": body
        },
        "data": {}
    });

    axios.post('https://fcm.googleapis.com/fcm/send', data, {
        headers: {
            'Authorization': 'key=AAAA7QT30kU:APA91bHvzwN4ZAHBrMZA3BHZ8VmOBXWC2trvJ7zQNjRauwQg3SdouV_rDuyaBufPGBFx3tMgfibzwYoN8abtoK-pA_W2semm271APn0XhclSdrx_BkL_v6F6tJw-g9XaLaTp0TxxsjGO',
            'Content-Type': 'application/json'
        }
    }).then(() => {
        toast.success("Notifikasi berhasil dikirim")
    }).catch(() => {
        toast.error("Notifikasi gagal dikirim")
    })

}